import { getIconProps, type IconProps } from '#types'

/**
 * Close icon — X mark for closing / dismissing actions.
 *
 * Used for close buttons, dismissing dialogs, removing filters, etc.
 * Stroke-based X icon with two crossed lines.
 *
 * @example
 * ```tsx
 * <button>
 *   <CloseIcon className="h-4 w-4" />
 * </button>
 * ```
 */
export function CloseIcon({ strokeWidth = 2, ...props }: IconProps) {
  return (
    <svg {...getIconProps(props)} viewBox="0 0 24 24">
      <path
        d="M18 6L6 18M18 18L6 6"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  )
}
